import { Provider } from '@radix-ui/react-tooltip';
import { type ComponentProps, type ReactElement } from 'react';

const TooltipProvider = ({
  delayDuration = 0,
  ...props
}: ComponentProps<typeof Provider>): ReactElement => (
  <Provider data-slot="tooltip-provider" delayDuration={delayDuration} {...props} />
);

export { TooltipProvider };
